module.exports = __webpack_public_path__ + "img/Ventanas y Estilos2.951fc8e4.webp";